import React, { useEffect, useState } from "react";
import "./Footer.css";
import axiosConfig from "../../Service/axiosConfig";
import { NavLink } from "react-router-dom";
import { PiMapPinLight } from "react-icons/pi";

const Footer = () => {
  const [stores, setStores] = useState([]);
  const [Data, SetData] = useState([]);
  const [Email, Setemail] = useState({});
  const [error, setError] = useState("");
  const [siteData, setSiteData] = useState({});
  const [policy, setPolicy] = useState({});
  const [brands, setBrands] = useState([]);
  const [visibleCount, setVisibleCount] = useState(6);

  useEffect(() => {
    setSiteData(JSON.parse(localStorage.getItem("site_data") || "{}"));

    axiosConfig
      .get("/catlog/categories/?page_size=30&is_suspended=false")
      .then((res) => SetData(res.data.results || []))
      .catch(console.error);

    axiosConfig
      .get(`catlog/brands/?page_size=1000`)
      .then((res) => setBrands(res.data.results || []))
      .catch(console.error);

    axiosConfig
      .get(`/stores/stores/?page=1&page_size=50&is_suspended=false`)
      .then((res) => setStores(res.data.results || []))
      .catch(console.error);
  }, []);

  const GetEmail = async () => {
    try {
      await axiosConfig.post(`/masters/subscribe/`, Email);
      setError("✓ Subscribed successfully!");
    } catch (err) {
      const msg = err.response?.data?.email?.[0];
      setError(
        msg === "Enter a valid email address."
          ? "Invalid email address."
          : msg === "subscribe with this email already exists."
            ? "Already subscribed."
            : "Something went wrong."
      );
    }
  };

  const hasMoreLocations = stores.length > visibleCount;
  const visibleStores = stores.slice(0, visibleCount);
  const copyrightData = siteData?.copy_right ? JSON.parse(siteData.copy_right) : null;

  return (
    <footer className="footer-container">
      <div className="container" style={{
        marginLeft: "auto",
        marginRight: "auto",
      }}>
        {/* ── Main Grid ── */}
        <div className="footer-main row">

          {/* Col 1 – Brand / About */}
          <div className="col-lg-3 col-md-6 footer-col">
            <h6 className="footer-heading">
              {copyrightData?.website || siteData?.name || "Our Store"}
            </h6>
            <p className="footer-about">
              Your trusted destination for quality products. Shop with confidence.
            </p>

            {/* Newsletter */}

          </div>

          {/* Col 2 – Useful Links */}
          <div className="col-lg-2 col-md-6 footer-col">
            <h6 className="footer-heading">Quick Links</h6>
            <ul className="footer-list">
              <li><NavLink to="/aboutus">About Us</NavLink></li>
              <li><NavLink to="/contactus">Contact Us</NavLink></li>
              <li><NavLink to="/blogs">Blogs</NavLink></li>
              {brands.length > 0 && <li><NavLink to="/brands">Brands</NavLink></li>}
              {policy?.privacy_policy && <li><NavLink to="/privacy">Privacy Policy</NavLink></li>}
              {policy?.terms_conditions && <li><NavLink to="/terms-services">Terms &amp; Conditions</NavLink></li>}
              {policy?.faq && <li><NavLink to="/faqs">FAQs</NavLink></li>}
              {policy?.return_policy && <li><NavLink to="/return-policy">Return Policy</NavLink></li>}
              {policy?.cancellation && <li><NavLink to="/cancellation">Cancellation</NavLink></li>}
            </ul>
          </div>

          {/* Col 3 – Categories */}
          <div className="col-lg-4 col-md-6 footer-col">
            <h6 className="footer-heading">Categories</h6>
            <ul className="footer-list footer-cat-grid">
              {Data.map((cat) => (
                <li key={cat.id}>
                  <NavLink to={`/${cat.slug}`}>{cat.name}</NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4 – Contact & Social */}
          <div className="col-lg-3 col-md-6 footer-col">
            <h6 className="footer-heading">Connect With Us</h6>

            {siteData?.address && (
              <div className="footer-address">
                <PiMapPinLight size={16} style={{ marginRight: 6, color: "var(--primary_color)" }} />
                {siteData.address}
              </div>
            )}
            {siteData?.phone && (
              <p className="footer-contact">📞 {siteData.phone}</p>
            )}
            {siteData?.email && (
              <p className="footer-contact">✉️ {siteData.email}</p>
            )}

            {/* Social Icons */}
            <div className="social-icons">
              {siteData?.facebook && (
                <img src={require("./images/facebook.png")} className="soc-icon" onClick={() => window.open(siteData.facebook, "_blank")} alt="Facebook" />
              )}
              {siteData?.instagram && (
                <img src={require("./images/instagram.png")} className="soc-icon" onClick={() => window.open(siteData.instagram, "_blank")} alt="Instagram" />
              )}
              {siteData?.linkedn && (
                <img src={require("./images/linkedin.png")} className="soc-icon" onClick={() => window.open(siteData.linkedn, "_blank")} alt="LinkedIn" />
              )}
              {siteData?.youtube && (
                <img src={require("./images/Youtube.jpg")} className="soc-icon" onClick={() => window.open(siteData.youtube, "_blank")} alt="YouTube" />
              )}
              {siteData?.twitter && (
                <img src={require("./images/Twitter.jpg")} className="soc-icon" onClick={() => window.open(siteData.twitter, "_blank")} alt="Twitter" />
              )}
            </div>

            {/* App Download */}
            {siteData?.android_link && (
              <NavLink className="download-app-link" target="_blank" to={siteData.android_link}>
                Download App&nbsp;
                <img src={require("./images/android.webp")} alt="Android" />
              </NavLink>
            )}
          </div>
        </div>

        {/* ── Locations ── */}
        {siteData?.ecommerce_type !== "Conventional" && stores.length > 0 && (
          <div className="footer-locations">
            <h6 className="footer-heading">Our Locations</h6>
            <div className="locations-grid">
              {visibleStores.map((loc, i) => (
                <span key={i} className="location-item">
                  <PiMapPinLight size={14} style={{ marginRight: 4 }} />
                  {loc.store_location}
                </span>
              ))}
            </div>
            {hasMoreLocations && (
              <button className="see-more-btn" onClick={() => setVisibleCount((c) => c + 6)}>
                See More
              </button>
            )}
          </div>
        )}
      </div>

      {/* ── Bottom Bar ── */}
      <div className="footer-bottom-bar">
        <div className="footer-bottom-inner">
          <p className="copyright">
            Copyright &copy; {copyrightData?.website || "Store"},{" "}
            {new Date().getFullYear()} · All Rights Reserved
          </p>
          {siteData?.maintained_by && (
            <p className="powered-by">
              Developed &amp; Maintained by{" "}
              <a href={`https://${siteData.maintained_by}`} target="_blank" rel="noreferrer">
                {siteData.maintained_by}
              </a>
            </p>
          )}
        </div>
      </div>
    </footer>
  );
};

export { Footer };
